class AutocompleteMakers extends window.BAO.CustomElement() {
  connectedCallback () {
    const makersList = []
    this.els['makers-data'].elements.forEach(li => {
      makersList.push({
        title: li.getAttribute('data-title'),
        url: li.getAttribute('data-url'),
      })
    })
    this.makersList = makersList
    window.theme.autocompleteResults.makersList = makersList

    this.subscribeToEvents()
    return super.connectedCallback()
  }

  subscribeToEvents () {
    window.theme.autocompleteResults.eventBus.subscribe(
      'api:makers:fetched',
      records => {
        this.handleMakersFetched(records)
      },
    )
  }

  handleMakersFetched (records) {
    const searchTerm = (
      window.theme.autocompleteResults.searchTerm || ''
    ).toLowerCase()

    if (!searchTerm) {
      window.theme.autocompleteResults.eventBus.publish(
        'state:matchedMakers:updated',
        [],
      )
      return
    }

    const titleStarts = []
    const wordStarts = []

    for (const maker of this.makersList) {
      const lower = maker.title.toLowerCase()
      if (lower.startsWith(searchTerm)) {
        titleStarts.push(maker)
      } else if (lower.split(/\s+/).some(word => word.startsWith(searchTerm))) {
        wordStarts.push(maker)
      }
    }

    const merged = [...titleStarts, ...wordStarts].slice(
      0,
      window.theme.collection.quickLinksLimit,
    )

    window.theme.autocompleteResults.eventBus.publish(
      'state:matchedMakers:updated',
      merged,
    )
  }

  getHandle (url) {
    const path = url.replace(/^https?:\/\/[^/]+/, '')
    return path
      .replace(/^\/collections\//, '')
      .toLowerCase()
      .split('?')[0]
  }
}

if (!customElements.get('autocomplete-makers')) {
  customElements.define('autocomplete-makers', AutocompleteMakers)
}
